export default __webpack_public_path__ + "static/media/30.0d4a7fe3.png";